import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'languageName',
  pure: false,
  standalone: false,
})
export class LanguageNamePipe implements PipeTransform {
  transform(language: string) {
    switch (language) {
      case 'ar': return 'Arabic'
      case 'de': return 'German'
      case 'en': return 'English'
      case 'es': return 'Spanish'
      case 'fa': return 'Farsi'
      case 'fr': return 'French'
      case 'hi': return 'Hindi'
      case 'it': return 'Italian'
      case 'ko': return 'Korean'
      case 'pl': return 'Polish'
      case 'ru': return 'Russian'
      case 'tl': return 'Tagalog'
      case 'vi': return 'Vietnamese'
      case 'zh': return 'Chinese'
      default: return ''
    }
  }
}
